/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { XenialCatalogEntry } from '../../models/xenial-catalog-entry';

export interface XenialCatalogsCatalogEntryIdPut$Params {
  'Active-Tenant-Identifier': string;
  catalogEntryId: string;
      body: XenialCatalogEntry
}

export function xenialCatalogsCatalogEntryIdPut(http: HttpClient, rootUrl: string, params: XenialCatalogsCatalogEntryIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, xenialCatalogsCatalogEntryIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

xenialCatalogsCatalogEntryIdPut.PATH = '/xenial/catalogs/{catalogEntryId}';
